import { createFileRoute } from "@tanstack/react-router"
import { Hero } from "@/components/sections/Hero"
import { Services } from "@/components/sections/Services"
import { Contact } from "@/components/sections/Contact"
import { SEO } from "@/components/SEO"
import { StructuredData } from "@/components/StructuredData"
import { homePage } from "@/content"

export const Route = createFileRoute("/")({
  component: HomePage,
})

function HomePage() {
  return (
    <>
      <SEO metadata={homePage.seo} />
      <StructuredData type="home" services={homePage.services} />
      <Hero section={homePage.hero} />
      <Services section={homePage.services} />
      <Contact section={homePage.contact} />
    </>
  )
}
